export type ProviderInstructions = {
	steps: string[];
	tip: string;
	displayName: string;
};

export const getProviderInstructions = (
	providerCode?: string
): ProviderInstructions => {
	switch (providerCode) {
		case 'gcash':
			return {
				displayName: 'GCash',
				steps: [
					'Save this QR code and open your GCash app',
					'Upload or scan the QR code using the GCash QR scanner to complete your payment',
				],
				tip: 'Tip: You can also forward this QR for someone else to make a payment for your Salmon',
			};

		case 'maya':
			return {
				displayName: 'Maya',
				steps: [
					'Save this QR code and open your Maya app',
					'Upload or scan the QR code using the Maya QR scanner to complete your payment',
				],
				tip: 'Tip: You can also forward this QR for someone else to make a payment for your Salmon',
			};

		case 'qrphpay':
		default:
			return {
				displayName: 'QR Ph',
				steps: [
					"Download this QR Ph code on your device's photo gallery",
					"Open GCash or any other bank app you'll use to make the repayment",
					"Use the app's QR payment feature to upload or scan the saved QR Ph code and complete the payment",
				],
				tip: 'Tip: You can also forward this QR for someone else to make a payment for your Salmon',
			};
	}
};
